// src/services/profile.js
import api from "./api";

const profileService = {
  // Get complete profile data
  getProfile: async () => {
    const response = await api.get("/employee/profile");
    return response.data;
  },

  // Update personal information
  updatePersonalInfo: async (data) => {
    const response = await api.put("/employee/profile", {
      name: data.name,
      phone: data.phone,
      address: data.address,
      emergencyContactName: data.emergencyContactName,
      emergencyContactPhone: data.emergencyContactPhone,
    });
    return response.data;
  },

  // Update profile photo
  updateProfilePhoto: async (photoBlob) => {
    const formData = new FormData();
    formData.append("photo", photoBlob, "profile-photo.jpg");

    const response = await api.post("/employee/profile/avatar", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Update emergency contact (included in updatePersonalInfo)
  updateEmergencyContact: async (data) => {
    const response = await api.put("/employee/profile", data);
    return response.data;
  },

  // Change password
  changePassword: async (data) => {
    const response = await api.post("/auth/change-password", data);
    return response.data;
  },

  // Get leave balance
  getLeaveBalance: async () => {
    const response = await api.get("/employee/leaves/balance");
    return response.data;
  },

  // Delete profile photo
  deleteProfilePhoto: async () => {
    const response = await api.delete("/employee/profile/avatar");
    return response.data;
  },

  // Get security settings
  getSecuritySettings: async () => {
    const response = await api.get("/employee/profile/settings");
    return response.data;
  },

  // Enable/disable two-factor authentication
  toggleTwoFactor: async (enable) => {
    const response = await api.post("/auth/two-factor", { enable });
    return response.data;
  },

  // Get activity logs
  getActivityLogs: async (page = 1, limit = 20) => {
    const response = await api.get("/employee/security/activity", {
      params: { page, limit },
    });
    return response.data;
  },

  // Export personal data (GDPR compliance)
  exportPersonalData: async () => {
    const response = await api.get("/employee/reports/personal-data", {
      responseType: "blob",
    });
    return response.data;
  },

  // Get notifications
  getNotifications: async (page = 1, limit = 10) => {
    const response = await api.get("/employee/notifications", {
      params: { page, limit },
    });
    return response.data;
  },

  // Mark notification as read
  markNotificationAsRead: async (notificationId) => {
    const response = await api.put(`/employee/notifications/${notificationId}/read`);
    return response.data;
  },
};

export default profileService;
